module.exports = __webpack_public_path__ + "static/media/e26.e1116063.jpg";